export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-en-AU.5a9ffdab.xlsx";